<template>
  <div class="firstInterviewPartA">
      <div class="main">
        <div class="title">家长问卷</div>
        <div class="part">
          <div class="titles">
            基本信息部分
          </div>
          <div style="width:650px;margin:0 auto">
            <div class="title">
              <Title title="家长基本信息"></Title>
            </div>
            <ul class="list">
              <li>母亲职业：{{form.motherOccupation}}</li>
              <li>工作单位：{{form.motherEmployer}}</li>
              <li>父亲职业：{{form.dadOccupation}}</li>
              <li>工作单位：{{form.dadEmployer}}</li>
              <li>家庭类型：{{form.familyType}}</li>
              <li>是否独生：{{form.isOnlyChild}}</li>
            </ul>
          </div>
        </div>
        <div class="buchong">
          <span></span>
          补充信息：
          <div class="textare">
            <el-input
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="baseInfo" >
            </el-input>
          </div>
        </div>
        <div class="part">
          <div class="titles">学生个人情况</div>
          <div style="width:650px;margin:0 auto">
            <div class="title">
              <Title title="学生个人情况"></Title>
            </div>
            <table>
              <tbody>
              <tr>
                <th>学生情况</th>
                <th>家长评价</th>
                <th>学生自评</th>
              </tr>
              <tr>
                <td>学生的兴趣爱好：</td>
                <td>{{form.studentHobby}}</td>
                <td>{{forms.myHobby}}</td>
              </tr>
              <tr>
                <td>学生的优点：</td>
                <td>{{form.studentAdvantage}}</td>
                <td>{{forms.mySpecialty}}</td>
              </tr>
              <tr>
                <td>学生的缺点：</td>
                <td>{{form.studentdisadvantage}}</td>
                <td>{{forms.myShortcomings}}</td>
              </tr>
              <tr>
                <td>学生最好的朋友：</td>
                <td>{{form.studentBestFirend}}</td>
                <td>{{forms.myBestFriend}}</td>
              </tr>
              <tr>
                <td>学生喜欢的书：</td>
                <td>{{form.studentLikeBook}}</td>
                <td>{{forms.myLikeBook}}</td>
              </tr>
              <tr>
                <td>学生喜欢的电影：</td>
                <td>{{form.studentLikeMovie}}</td>
                <td>{{forms.myLikeMovie}}</td>
              </tr>
              <tr>
                <td>学生喜欢的明星：</td>
                <td>{{form.studentLikeStar}}</td>
                <td>{{forms.myLikeStar}}</td>
              </tr>
              <tr>
                <td>学生的向往的职业：</td>
                <td>{{form.studentLookOccupation}}</td>
                <td>{{forms.myLikeCareer}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="buchong">
            <span></span>
            补充信息：
            <div class="textare">
              <el-input
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="studentSelfSituation" >
              </el-input>
            </div>
          </div>
        </div>
        <div class="part">
          <div class="titles">学习现状部分</div>
          <div style="width:650px;margin:0 auto">
            <div class="title">
              <Title title="学习现状部分"></Title>
            </div>
            <table>
              <tbody>
              <tr>
                <th>主管孩子学习</th>
                <th>陪同完成作业</th>
                <th>辅导孩子作业</th>
                <th>检查孩子作业</th>
              </tr>
              <tr>
                <td>{{form.learnManageStudent}}</td>
                <td>{{form.learnAccompany}}</td>
                <td>{{form.learnTutoring}}</td>
                <td>{{form.learnCheckHomework}}</td>
              </tr>
              </tbody>
            </table>
            <table style='margin-top:30px'>
              <tbody>
              <tr>
                <th>孩子预习情况</th>
                <th>孩子复习情况</th>
                <th>孩子考试情况</th>
                <th>孩子反映课堂</th>
              </tr>
              <tr>
                <td>{{form.learnPreview}}</td>
                <td>{{form.learnReview}}</td>
                <td>{{form.learnExamSituation}}</td>
                <td>{{form.learnFeedbackClass}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="buchong">
            <span></span>
            补充信息：
            <div class="textare">
              <el-input
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="studentLearnSituation" >
              </el-input>
            </div>
          </div>
        </div>
        <div class="part">
          <div class="titles"> 日常生活部分</div>
          <div style="width:650px;margin:0 auto">
            <div class="title">
              <Title title="日常生活部分"></Title>
            </div>
          </div>
          <div style="width:650px;margin:0 auto">
            <p style="font-weight: bolder">最近和孩子一起开展的亲子活动/一起看的书或电影：</p>
            <p>{{form.lifeActivity}}</p>
            <p style="font-weight: bolder">孩子近期做过的最让您或您的家人感动的事：</p>
            <p>{{form.lifeMoved}}</p>
            <p style="font-weight: bolder">您与孩子之间是否存在交流沟通方面的问题：</p>
            <p>{{form.lifeExchange}}</p>
            <p style="font-weight: bolder">孩子成长（学习&生活）过程中最让您担心的是：</p>
            <p>{{form.lifeWorry}}</p>
          </div>
          <div class="buchong">
            <span></span>
            补充信息：
            <div class="textare">
              <el-input
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="dailyLife" >
              </el-input>
            </div>
          </div>
        </div>
        <div class="part">
          <div class="titles">其他部分</div>
          <div style="width:650px;margin:0 auto">
            <div class="title">
              <Title title="其他部分"></Title>
            </div>
          </div>
          <div style="width:650px;margin:0 auto">
            <p>您希望孩子在学习之外哪些方面得到提升：{{form.otherPromote&&form.otherPromote.toString()}}</p>
            <p>您认为在指导孩子的过程中，您需要补充哪些方面的内容：{{form.otherSupplement}}</p>
            <p style="font-weight:bolder">您觉得我们需要了解孩子的特殊情况：</p>
            <p>{{form.otherAspect}}</p>
          </div>
          <div class="buchong">
            <span></span>
            补充信息：
            <div class="textare">
              <el-input
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="other" >
              </el-input>
            </div>
          </div>
        </div>
        <div class="part">
          <div class="circleTitle">
            <span style="background:#CECECE"></span>
            <span style="background:#8C8C8C"></span>
            <span></span>
            <a>咨询总结</a>
            <span></span>
            <span style="background:#8C8C8C"></span>
            <span style="background:#CECECE"></span>
          </div>
          <div class="buchongs">
            <span></span>
            <div class="textare">
              <el-input
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="consultantSummary" >
              </el-input>
            </div>
        </div>
      </div>
        <div class="part">
          <div class="circleTitle">
            <span style="background:#CECECE"></span>
            <span style="background:#8C8C8C"></span>
            <span></span>
            <a>反馈家长</a>
            <span></span>
            <span style="background:#8C8C8C"></span>
            <span style="background:#CECECE"></span>
          </div>
          <div class="buchongs">
            <span></span>
            <div class="textare">
              <el-input
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="feedbackToParent" >
              </el-input>
            </div>
          </div>
        </div>
        <div class="part">
          <ul class="bottom" :style="{display:show?'none':'block' }">
            <div  class="button hover" @click="submit({path:'/consultant/newstudent/main/home',query:$route.query})">确认返回</div>
            <!-- <div  class="button hover"  style="float: right" @click="submit({path:'/consultant/newstudent/main/firstInterviewPartB2',query:$route.query})">前往测评报告解读</div> -->
          </ul>
          <ul class="bottom" :style="{display:show?'block':'none',textAlign:'center'}">
            <div   style="margin:0 auto" class="button hover" @click="$router.go(-1)">返回</div>
          </ul>
        </div>
   </div>
   <Popup v-if="popup_bool" :inter-view="interView" :status="status" :query="$route.query" :getPopupBool="getPopupBool"></Popup>
  </div>
</template>

<script>
import Title from '@/components/consultant/MessageTitle.vue'
import Popup from '@/components/xueyezixun/InterviewPopup'
export default {
  name: "firstInterviewPartA",
  components:{
    Title,
    Popup
  },
  data() {
    return {
      studentId:this.$route.query.studentId,
      studentName:'',
      reportId:'',
      interView:[{
        category:1,
        interViewTheme:'首次访谈'
      }],
      popup_bool:false,
      // popup_bool:true,
      status:1,
      form:{

      },
      forms:{

      },
      baseInfo:'',
      studentSelfSituation:'',
      studentLearnSituation:'',
      dailyLife:'',
      other:'',
      consultantSummary:'',
      feedbackToParent:'',
      show:this.$route.query.show=='已完成'?true:false
    }
  },
  methods: {
    // toParent(){
    //   this.$emit('event1','>首次访谈')
    // },
    getPopupBool(bool) {
      this.popup_bool= bool
    },
    getPopupData(obj){
      this.interViewData=obj
    },
    toParent(){
      this.$emit('event1','>首次访谈-家长问卷访谈')
    },
    getData() {
      //获取父母数据
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.getParentCensusQuestion, {
        studentId:this.$route.query.studentId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.form=res.data.data.censusQuestion
        } else {
        }
      })
      //获取学生数据
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.getStudentCensusQuestion, {
        studentId:this.$route.query.studentId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
           this.forms=res.data.data.censusQuestion
        }
      })
      if(!this.show){
        return
      }
      //获取访谈详情
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.detailA, {
        studentId:this.$route.query.studentId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          const {baseInfo,studentSelfSituation, studentLearnSituation,dailyLife,
            other,consultantSummary,feedbackToParent} = res.data.data;
          this.baseInfo=baseInfo
          this.studentSelfSituation=studentSelfSituation
          this.studentLearnSituation=studentLearnSituation
          this.dailyLife=dailyLife
          this.other=other
          this.consultantSummary=consultantSummary
          this.feedbackToParent=feedbackToParent
        } else {
        }
      })

    },
    getData1(){
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.process,{
              studentId:this.$route.query.studentId
            },{
              headers: {
                token: window.sessionStorage.getItem('ymtxToken')
              }
            }).then(res=>{
              if(res.data.code==2000){
                const { status } = res.data.data;
                this.state = status
                // console.log(state)
                if(status==1){
                  
                  this.popup_bool=true;
                  // console.log(this.popup_bool)
                }
              }else{
              }
            })
    },
    submit(url){
      const {baseInfo,studentSelfSituation, studentLearnSituation,dailyLife,
        other,consultantSummary,feedbackToParent}=this;
      if(!(baseInfo&&studentLearnSituation&&studentSelfSituation&&dailyLife&&other
          &&consultantSummary&&feedbackToParent)){
        this.$message.error('请先完成报告填写。')
        return;
      }
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.addA, {
        studentId:this.$route.query.studentId,
        baseInfo:baseInfo,
        studentSelfSituation:studentSelfSituation,
        studentLearnSituation:studentLearnSituation,
        dailyLife:dailyLife,
        other:other,
        consultantSummary:consultantSummary,
        feedbackToParent:feedbackToParent
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.$router.push(url)
        }
      })
    }
  },
  mounted() {
    console.log(typeof(this.$route.query.show))
    this.getData();
    this.toParent();
    this.getData1();   
  }
}
</script>

<style scoped lang="less">
.firstInterviewPartA{
  *,body{
    font-size: 16px;
  }
  padding-bottom: 100px;
  .main{
    width: 970px;
    background: #fff;
    border: 1px solid #D9D9D9;
    margin: 0 auto;
    padding: 0 40px 40px;
    box-sizing: border-box;
  }
  .title{
    margin-top: 20px;
    color: #0091EA;
    height: 67px;
    font-size: 48px;
    text-align: center;
    div{
      font-size: 18px;
      font-weight: normal;
    }
  }
  .titles{
    margin: 60px 0 10px;
    height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #5C5C5C;
    line-height: 28px;
    font-weight: bold;
  }
  .list{
    overflow: hidden;
    li{
      width: 50%;
      float: left;
      line-height: 38px;
    }
  }
  .buchong{
    font-size: 15px;
    span{
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background:#00A2FF;
      margin-right: 10px;
    }
    .textare{
      margin-top: 20px;
      textarea{
        min-height: 96px;
        font-size: 14px;
      }
    }
  }
  table{
    width: 100%;
    color:#000;
    border-collapse: collapse;
    border:1px solid #DBEEFA;
    th{
      background: #F0F9FE;
    }
    th,td{
      line-height: 36px;
      text-align: center;
      border:1px solid #DBEEFA;
      font-size: 16px;
    }
    td:first-child{
      background: #F9FDFF;
    }
  }
  p{
    line-height: 34px;
    font-size: 16px;
  }
  .circleTitle{
    display: flex;
    justify-content: space-between;
    width: 188px;
    font-size: 20px;
    color: #5C5C5C;
    font-weight: bold;
    margin: 30px auto;
    line-height: 30px;
    a{
      margin: 0 10px;
      color: #5C5C5C;
      font-size: 20px;
      font-weight: bolder;
    }
    span{
      display: block;
      width: 8px;
      height: 8px;
      background: #5C5C5C;
      border-radius: 50%;
      position: relative;
      top:11px;
    }
  }
  .buchongs{
    textarea{
      min-height: 140px;
    }
  }
  .buttons{
    width: 418px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
  }
  .bottom{
    width: 400px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    text-align: center;
    li{
      width: 128px;
      height: 32px;
      line-height: 32px;
      background: #C8C6C6;
      box-shadow: 0px 4px 6px 0px rgba(196, 196, 196, 0.4);
      border-radius: 15px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      cursor: pointer;
    }
    .newActive{
      color:#fff;
      background:#0094EA;
    }
  }
  .cancelButton{
    width:960px;
    margin: 60px auto 20px;
  }
  .button{
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
    background: #ECF8FE;
    color: #1EA2EE;
    border: 1px solid #76C6F4;
    display: inline-block;
    padding: 0 20px;
  }
  .hover{
    cursor: pointer;
    &:hover{
      background: #099BEF !important;
      color: #fff !important;
    }
  }
}
</style>
<style lang="less">
.firstInterviewPartA{
  .title{
    .title{
        font-size: 18px;
        font-weight: normal;
    }
  }
  .textare{
    margin-top: 20px;
    textarea {
      min-height: 96px !important;
      font-size: 14px
    }
  }
  .buchongs {
      textarea {
        min-height: 140px !important;
      }
  }
}
</style>